export default function Marquee() {
  const words = ["CONTENT", "SYSTEMS", "SHORT-FORM", "DISTRIBUTION", "REVENUE"];
  const row = (
    <div className="flex shrink-0 items-center">
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`text-huge uppercase px-8 ${
              w === "REVENUE" ? "text-lav-400" : "text-white/90"
            }`}
          >
            {w}
          </span>
          <span className="text-lav-400 text-2xl">✳</span>
        </span>
      ))}
    </div>
  );
  return (
    <section className="relative border-y border-white/[0.06] py-10 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee will-change-transform">
        {row}
        {row}
      </div>
    </section>
  );
}
